import { extraSmall } from './sizes/extraSmall';
import { small } from './sizes/small';
import { medium } from './sizes/medium';
import { large } from './sizes/large';

const inputStyleFactory = size => {
  switch (size) {
    case 'extraSmall':
      return extraSmall();
    case 'small':
      return small();
    case 'medium':
      return medium();
    case 'large':
      return large();
    default:
      return medium();
  }
};

export { inputStyleFactory };
